import { createClient, type SupabaseClient } from '@supabase/supabase-js';
import type { Database } from './database.types.js';

// Dit pakket is de enige plek die @supabase/supabase-js rechtstreeks kent; de
// apps praten alleen met @qc/db. Wie de fout van een mislukte edge-function-
// aanroep wil uitlezen heeft deze klasse nodig, dus die geven we hier door.
export { FunctionsHttpError } from '@supabase/supabase-js';

export type QcClient = SupabaseClient<Database>;

export interface ClientInstellingen {
  url: string;
  sleutel: string;
}

/**
 * Maakt een Supabase-client. De apps geven hun eigen instellingen mee, zodat
 * dit pakket niets weet van Vite of van omgevingsvariabelen.
 *
 * Let op regel 2: de kassa praat niet rechtstreeks met deze client tijdens het
 * afslaan van een bon. Alleen de synclaag gebruikt hem.
 */
export function maakClient(instellingen: ClientInstellingen): QcClient {
  if (!instellingen.url || !instellingen.sleutel) {
    throw new Error(
      'Supabase-instellingen ontbreken. Zet VITE_SUPABASE_URL en VITE_SUPABASE_ANON_KEY in .env',
    );
  }
  return createClient<Database>(instellingen.url, instellingen.sleutel, {
    auth: { persistSession: true, autoRefreshToken: true },
  });
}
